import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Min:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Max:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectField = _resolveComponent("SelectField")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.stackCssClass, "gap-2"])
  }, [
    _createVNode(_component_SelectField, {
      modelValue: _ctx.dropdownValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dropdownValue) = $event)),
      "select-items": _ctx.witnessAgeList,
      "is-horizontal": false,
      "is-required": true
    }, null, 8, ["modelValue", "select-items"]),
    (_ctx.selectionMode === 'range')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.stackCssClass, "gap-2 mt-2 text-start"])
        }, [
          _createVNode(_component_SelectField, {
            modelValue: _ctx.minAge,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minAge) = $event)),
            "select-items": _ctx.minAges,
            "is-horizontal": false,
            "is-required": true,
            style: {"min-width":"150px"}
          }, {
            label: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["modelValue", "select-items"]),
          _createVNode(_component_SelectField, {
            modelValue: _ctx.maxAge,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maxAge) = $event)),
            "select-items": _ctx.maxAges,
            "is-horizontal": false,
            "is-required": true,
            style: {"min-width":"150px"}
          }, {
            label: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["modelValue", "select-items"])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}